import { version1Stores } from "./v1";

export const version2Stores = {
  ...version1Stores,
  recipes: "&id, name, updatedAt",
} as const;
